import { TranslationType } from "../types";
import { dashboard } from "./es/dashboard";
import { landing } from "./es/landing";
import { story } from "./es/story";
import { common } from "./es/common";
import { settings } from "./es/settings";
import { auth } from "./es/auth";
import { navigation } from "./es/navigation";
import { profile } from "./es/profile";
import { errors } from "./es/errors";
export const es: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...navigation,
  ...profile,
  ...errors
};
